var mp = mp || {};

// Product variations (single product page)
// Custom replacement for WooCommerce's variation form: picks the variation from
// the selected attributes, updates price, stock, quantity limits, image and cart form
//-----------------------------------------------------------------
mp.productVariations = function () {
  var $wrapper = $("[data-product-variations]");

  if (!$wrapper.length) {
    return;
  }

  var variations = $wrapper.data("product_variations") || [],
    images = $wrapper.data("variation_images") || {},
    $selects = $wrapper.find(".variation-select"),
    $priceBox = $wrapper.find(".price-box"),
    $priceDefault = $wrapper.find(".price--variable"),
    $priceInfo = $wrapper.find(".price-info"),
    $form = $wrapper.find("form.cart"),
    $button = $form.find('button[type="submit"]'),
    $variationInput = $form.find('input[name="variation_id"]'),
    $qty = $form.find("input.qty"),
    selected = {};

  // Main gallery image (first item), restored when no variation is selected
  var $galleryLink = $(".products__main_gallery .products__main_gallery_item").first().find("a"),
    $galleryImage = $galleryLink.find("img"),
    originalImage = {
      src: $galleryImage.attr("src"),
      srcset: $galleryImage.attr("srcset"),
      sizes: $galleryImage.attr("sizes"),
      alt: $galleryImage.attr("alt"),
      href: $galleryLink.attr("href"),
    };

  // Variation attribute value '' means "any value"
  function matches(variation, selection) {
    return Object.keys(selection).every(function (attribute) {
      var value = variation.attributes[attribute];
      return value === "" || value === selection[attribute];
    });
  }

  function findVariation() {
    if (Object.keys(selected).length !== $selects.length) {
      return null;
    }

    for (var i = 0; i < variations.length; i++) {
      if (matches(variations[i], selected)) {
        return variations[i];
      }
    }

    return null;
  }

  // Disable options that have no variation with the other current selections
  function updateOptions() {
    $selects.each(function () {
      var attribute = this.dataset.attribute_name,
        others = $.extend({}, selected);

      delete others[attribute];

      $(this)
        .find("option")
        .each(function () {
          if (!this.value) {
            return;
          }

          var test = $.extend({}, others);
          test[attribute] = this.value;

          this.disabled = !variations.some(function (variation) {
            return matches(variation, test);
          });
        });

      if ($(this).data("selectric")) {
        $(this).selectric("refresh");
      }
    });
  }

  function setImage(image) {
    if (!$galleryImage.length) {
      return;
    }

    var img = image || originalImage;

    $galleryImage.attr("src", img.src);
    img.srcset ? $galleryImage.attr("srcset", img.srcset) : $galleryImage.removeAttr("srcset");
    img.sizes ? $galleryImage.attr("sizes", img.sizes) : $galleryImage.removeAttr("sizes");
    $galleryImage.attr("alt", img.alt || "");
    $galleryLink.attr("href", image ? image.full_src : img.href);
  }

  function setQuantityLimits(variation) {
    if (!$qty.length) {
      return;
    }

    var min = variation && variation.min_qty ? parseInt(variation.min_qty, 10) : 1,
      max = variation && variation.max_qty ? parseInt(variation.max_qty, 10) : "",
      value = parseInt($qty.val(), 10) || min;

    $qty.attr("min", min).attr("max", max);
    $qty.val(Math.max(min, max ? Math.min(max, value) : value));
  }

  function update() {
    var variation = findVariation();

    // Cart form attributes
    $selects.each(function () {
      $form.find('input[name="' + this.dataset.attribute_name + '"]').val(this.value);
    });

    $variationInput.val(variation ? variation.variation_id : "");
    $button.prop("disabled", !(variation && variation.is_in_stock && variation.is_purchasable));

    $priceDefault.toggle(!variation);
    $priceBox.html(variation ? variation.price_html : "");
    $priceInfo.html(variation ? variation.availability_html : "");

    setImage(variation && variation.image_id ? images[variation.image_id] : null);
    setQuantityLimits(variation);

    // Same events as WooCommerce's variation form, e.g. YITH wishlist switches to the variation
    if (variation) {
      $wrapper.trigger("found_variation", [variation]);
    } else {
      $wrapper.trigger("reset_data");
    }
  }

  $wrapper.on("change", ".variation-select", function () {
    if (this.value) {
      selected[this.dataset.attribute_name] = this.value;
    } else {
      delete selected[this.dataset.attribute_name];
    }

    updateOptions();
    update();
  });

  // Start from default attributes preselected in the template
  $selects.each(function () {
    if (this.value) {
      selected[this.dataset.attribute_name] = this.value;
    }
  });

  updateOptions();
  update();
};

// Add to cart without page reload (single product page, simple and variable products)
// Posts the cart form to the same URL WooCommerce normally uses, then shows the
// notices from the response as toasts and refreshes the header cart total
//-----------------------------------------------------------------
mp.addToCart = function () {
  var selector = ".products--single form.cart";

  if (!$(selector).length || !window.FormData || !window.DOMParser) {
    return;
  }

  $(document).on("submit", selector, function (e) {
    var form = this,
      $form = $(form),
      $button = $form.find('button[type="submit"]').first(),
      data = new FormData(form);

    e.preventDefault();

    if ($form.hasClass("is-loading")) {
      return;
    }

    // Simple products send the product ID as the submit button's value
    if (!data.has("add-to-cart") && $button.attr("name") === "add-to-cart") {
      data.append("add-to-cart", $button.val());
    }

    $form.addClass("is-loading");
    $button.prop("disabled", true);

    $.ajax({
      url: $form.attr("action") || window.location.href,
      type: "POST",
      data: data,
      processData: false,
      contentType: false,
      dataType: "html",
    })
      .done(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");

        $(doc)
          .find("[data-toasts]")
          .children(".woocommerce-message, .woocommerce-info, .woocommerce-error")
          .each(function () {
            mp.toast($(this));
          });

        // Header cart total (cart fragments)
        $(document.body).trigger("wc_fragment_refresh");
      })
      .fail(function () {
        // Fall back to a normal submit (not caught by this handler)
        form.submit();
      })
      .always(function () {
        $form.removeClass("is-loading");
        $button.prop("disabled", false);
      });
  });
};
